<app-thi-page-shell [lang]="landingLang">
<div class="privacy-policy pt-20">
	<div class="container">
		
		<div class="privacy-policy__header">
			<div class="privacy-policy__header-content">
				<h1 class="privacy-policy__title">
					{{ 'privacyPolicy.title' | translate }}
				</h1>
				<p class="privacy-policy__subtitle">
					{{ 'privacyPolicy.subtitle' | translate }}
				</p>
			</div>
		</div>

		<div class="privacy-policy__container">
			
			<p-card class="privacy-policy__card">
				<ng-template pTemplate="header">
					<div class="privacy-policy__card-header">
						<div class="privacy-policy__last-updated">
							<i class="pi pi-calendar"></i>
							<span>{{ 'privacyPolicy.lastUpdated' | translate }}: {{ 'privacyPolicy.lastUpdatedDate' | translate }}</span>
						</div>
					</div>
				</ng-template>

				<div class="privacy-policy__content">
					
					<div class="privacy-policy__section">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.sections.introduction.title' | translate }}</h2>
						<p>{{ 'privacyPolicy.sections.introduction.content1' | translate }}</p>
						<p>{{ 'privacyPolicy.sections.introduction.content2' | translate }}</p>
					</div>

					<div class="privacy-policy__section">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.sections.informationCollected.title' | translate }}</h2>
						<ul class="privacy-policy__list">
							<li>
								<strong>{{ 'privacyPolicy.sections.informationCollected.personal' | translate }}:</strong>
								{{ 'privacyPolicy.sections.informationCollected.personalDetails' | translate }}.
							</li>
							<li>
								<strong>{{ 'privacyPolicy.sections.informationCollected.business' | translate }}:</strong>
								{{ 'privacyPolicy.sections.informationCollected.businessDetails' | translate }}.
							</li>
							<li>
								<strong>{{ 'privacyPolicy.sections.informationCollected.technical' | translate }}:</strong>
								{{ 'privacyPolicy.sections.informationCollected.technicalDetails' | translate }}.
							</li>
						</ul>
					</div>

					<div class="privacy-policy__section">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.sections.useOfInformation.title' | translate }}</h2>
						<ul class="privacy-policy__list">
							<li>{{ 'privacyPolicy.sections.useOfInformation.invoicing' | translate }}</li>
							<li>{{ 'privacyPolicy.sections.useOfInformation.dataRetention' | translate }}</li>
							<li>{{ 'privacyPolicy.sections.useOfInformation.communication' | translate }}</li>
							<li>{{ 'privacyPolicy.sections.useOfInformation.improvement' | translate }}</li>
						</ul>
					</div>

					<div class="privacy-policy__section">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.sections.dataRetention.title' | translate }}</h2>
						
						<h3 class="privacy-policy__subsection-title">{{ 'privacyPolicy.sections.dataRetention.subtitle1' | translate }}</h3>
						<p>{{ 'privacyPolicy.sections.dataRetention.content1' | translate }}</p>
						
						<h3 class="privacy-policy__subsection-title">{{ 'privacyPolicy.sections.dataRetention.subtitle2' | translate }}</h3>
						<p>{{ 'privacyPolicy.sections.dataRetention.content2' | translate }}</p>
					</div>

					<div class="privacy-policy__section">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.sections.sharingInformation.title' | translate }}</h2>
						<p>{{ 'privacyPolicy.sections.sharingInformation.content1' | translate }}</p>
						<p>{{ 'privacyPolicy.sections.sharingInformation.content2' | translate }}</p>
					</div>

					<div class="privacy-policy__section">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.sections.userRights.title' | translate }}</h2>
						<p>{{ 'privacyPolicy.sections.userRights.content1' | translate }}</p>
						<p>{{ 'privacyPolicy.sections.userRights.content2' | translate }}</p>
					</div>

					<div class="privacy-policy__section">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.sections.changesToPolicy.title' | translate }}</h2>
						<p>{{ 'privacyPolicy.sections.changesToPolicy.content1' | translate }}</p>
						<p>{{ 'privacyPolicy.sections.changesToPolicy.content2' | translate }}</p>
					</div>

					<div class="privacy-policy__contact">
						<h2 class="privacy-policy__section-title">{{ 'privacyPolicy.contact.title' | translate }}</h2>
						<p>{{ 'privacyPolicy.contact.description' | translate }}</p>
						<div class="privacy-policy__contact-info">
							<i class="pi pi-envelope"></i>
							<span>{{ 'privacyPolicy.contact.email' | translate }}</span>
						</div>
					</div>
				</div>

			</p-card>

		</div>
	</div>
</div>
</app-thi-page-shell>